<template>
<div class="oh allchain" >
	<leftnav class="fl" mkcode="B" itemcode="B-CSDSJ" title="模板页面"></leftnav>
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">  
		<div class="whitebox right_topbox">
			<div class="right_boxtitle">
				<span class="fl right_title">模板页面</span> 
			</div>
			<div>
				<!-- <div class="opport-screen-list1"> 
						<dl class="opport-screen bdbe">
							<dt class="fl">大分类</dt>
							<dd class="fl">
							<span :class="searchtype == list.value?'a-screen current':'a-screen'" @click="searchtype = list.value;getlist(list.value);searchtype1=0" v-for="(list,i) in biglist">{{list.name}}</span>  
							</dd>
						</dl> 
				</div> -->
			</div> 
		</div> 
	<div class="index_block  whitebox oh" style="padding:30px 0px;margin-top: 10px;"> 
			 
	</div>
	</div>
	</div>
</div>
</template> 
<script>
	export default {
	  name: 'allchain',
			data(){return{ 
				title:"空白页-模板",
				userdata:{},   
			}},
			created(){  
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});
				this.userdata = this.getuseriformation();
		 
			},
			mounted() { 
			},
			methods: {
 
			
			},
	}
</script>

<style> 
  
</style>
